import {
    base64ToStr
} from "@/utils/index";
/*
 * 定义公共变量
 * */
//正则
export const regs = {
    mobile: /^1[3-9]\d{9}$/,
    num: /^((0(\.(\d+)?[1-9])?)|([1-9]\d*(\.\d+)?))?$/,
    numNoZero: /^((0\.(\d+)?[1-9])|([1-9]\d*(\.\d+)?))?$/,
    numZero: /^(0|\+?[1-9][0-9]*)$/, //包含0的正整数
    numZero1: /^[0-9]*[1-9][0-9]*$/, //不包含0的正整数
    numWithMinus: /^(-?((0(\.(\d+)?[1-9])?)|([1-9]\d*(\.\d+)?)))?$/,
    numTow: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, //大于零保留两位小数
    numTow1: /^(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/, //大于等于零保留两位小数
    zhongwen: /[\u4e00-\u9fa5]/,
    IDCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
    email: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
};
export const isAddTextMask = true
export const imgMaskUrl = `?watermark/4/text/${base64ToStr()}/fontsize/600/fill/Z3JheQ==/dissolve/65/rotate/30/uw/180/uh/180/resize/1`

export const imgUp = true
    /*************************测试环境***********************/
    // export const serverUrl = 'http://apitest.ngrok.room1000.com/';
    // export const serverUrl = 'http://192.168.180.174:8000/'
    // export const serverUrl = 'https://erp.room1000.com/'
    // export const serverUrl = 'http://172.16.3.212:8000/';
    // export const serverUrl = 'http://172.16.3.25:8000/';
    // export const serverUrl = 'http://192.168.110.213:8000/';
    // export const serverUrl = 'http://192.168.180.162:8000';
    // export const serverUrl = 'http://dev.ams-gateway.ngrok.room1000.com';

/*************************正式环境***********************/
export const serverUrl = 'https://merp.room1000.com/gateway/';
//
// export const _config = {
//     corpId: "ding26c6738defcfdfce",//企业id
//     agentId: "880228279"
// }

/*************************测试环境***********************/
// export const serverUrl = 'http://apigateway.ngrok.room1000.com/';

export const _config = {
    corpId: "ding26c6738defcfdfce", //企业id
    agentId: "816575109"
}